<script setup>
definePageMeta({
  middleware: ['not-authenticated'],
})

const { register } = useStrapiAuth()
const { executeRecaptcha } = useNuxtApp()?.$recaptcha

const generalData = ref({
  firstName: '',
  lastName: '',
  companyName: '',
  email: '',
  password1: '',
  password2: '',
})

const contactData = ref({
  address: '',
  postalCode: '',
  city: '',
  country: '',
  phone: '',
  agreedToTerms: false,
})

const errorMessage = ref('')

const step = ref(1)

function nextStep() {
  if (step.value < 2) {
    step.value++
  } else if (step.value === 2) {
    submit()
  }
}

function previousStep() {
  if (step.value > 1) {
    step.value--
  }
}

async function submit() {
  const address = {
    address: contactData.value.address,
    zip_code: contactData.value.postalCode,
    city: contactData.value.city,
    country: contactData.value.country,
  }

  const form = {
    recaptchaToken: await executeRecaptcha('register'),
    type: 'company',
    contact: {
      first_name: generalData.value.firstName,
      last_name: generalData.value.lastName,
      phone_number: contactData.value.phone,
    },
    address,
    email: generalData.value.email,
    username: generalData.value.email,
    password: generalData.value.password1,
    passwordConfirm: generalData.value.password2,
    companyDetails: {
      name: generalData.value.companyName,
      address,
      about: {
        info: [
          {
            title: 'FTE',
            content: '-1',
          },
          {
            title: 'Telefoon',
            content: contactData.value.phone,
          },
          {
            title: 'E-mailadres',
            content: generalData.value.email,
          },
        ],
      },
      media: [],
      highlight: [{ title: 'Highlights', items: [] }],
    },
    preferences: {
      dontReceiveCronJobEmails: false,
    },
  }
  try {
    await register(form)
    window?.dataLayer?.push({
      event: 'registerCompany',
      email: generalData.value.email,
      lname: generalData.value.lastName,
      fname: generalData.value.firstName,
    })

    navigateTo('/thankyoucompany')
  } catch (e) {
    switch (e.original.error.message) {
      case 'Email or Username are already taken':
        errorMessage.value = 'Dit e-mailadres is al in gebruik.'
        step.value = 1
        break
      case 'email must be a valid email':
        errorMessage.value = 'Dit e-mailadres is niet geldig.'
        step.value = 1
        break
      case 'password must be at least 6 characters':
        errorMessage.value = 'Het wachtwoord moet minimaal 6 tekens bevatten.'
        step.value = 1
        break
      default:
        errorMessage.value =
          'Er ging iets mis bij het registreren. Check uw gegevens en probeer het opnieuw.'
    }
  }
}
</script>

<template>
  <div class="flex flex-col items-center">
    <RegisterHero title="Registreer jouw bedrijf" />
    <div class="flex w-full justify-center">
      <div class="max-w-3xl grow px-6">
        <RegisterCompanyGeneralData
          v-if="step === 1"
          v-model="generalData"
          :error-message="errorMessage"
          class="my-12 bg-white"
          @next="nextStep"
        />
        <RegisterCompanyContactData
          v-if="step === 2"
          v-model="contactData"
          :error-message="errorMessage"
          class="my-12 bg-white"
          @next="nextStep"
          @prev="previousStep"
        />
      </div>
    </div>
  </div>
</template>
